import { useTranslation } from '../../i18n/useTranslation';
import styles from './fixcenter-career-job-offers.module.scss';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';

const CareerAccountManagerLuxJobOffer: React.FC = () => {
    const { t } = useTranslation('translation');
    const getTranslate = (code: string) => {
        return t('CAREER_ITEMS.' + code);
    };
    return (
        <>
            <div className={styles.job_offers_container}>
                <div className={styles.content}>
                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_49') }}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}
                            ></label>
                            <label
                                dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_50') }}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}
                            ></label>
                            <label
                                dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_51') }}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}
                            ></label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_52') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_5)}
                    ></label>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_53') }}
                        className={classNames(
                            globalStyles.float_left_item,
                            styles.h1,
                            globalStyles.underline_text,
                            globalStyles.mb_5
                        )}
                    ></label>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_54') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_2)}
                    ></label>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_55') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}
                    ></label>
                    <ul className={globalStyles.mb_1}>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_64')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_65')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_66')}</span>
                        </li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_56') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}
                    ></label>
                    <ul className={globalStyles.mb_5}>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_67')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_68')}</span>
                        </li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_57') }}
                        className={classNames(
                            globalStyles.float_left_item,
                            styles.h1,
                            globalStyles.underline_text,
                            globalStyles.mb_5
                        )}
                    ></label>
                    <ul className={globalStyles.mb_2}>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_69')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_70')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_71')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_72')}</span>
                        </li>
                        <li>
                            <span className={styles.h2}>{getTranslate('LI_73')}</span>
                        </li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_58') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}
                    ></label>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_59') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}
                    ></label>
                    <label
                        dangerouslySetInnerHTML={{ __html: getTranslate('HEADER_60') }}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}
                    ></label>
                </div>
            </div>
        </>
    );
};

export default CareerAccountManagerLuxJobOffer;
